import Vue from "vue"
import Vuex from "vuex"
import axios from "axios"

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		user: null,
	},
	mutations: {
		setUser(state, user) {
			state.user = user
		}
	},
	actions: {
		updateUser({commit}) {
			axios.get("/current_user")
				.then(res => res.data)
				.then(data => {
					commit('setUser', data)
				})
		}
	}
})

export default store



// WEBPACK FOOTER //
// ./src/store.js